var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "drag")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.312 20v-2.688h21.376v2.688h-21.376zM26.688 12v2.688h-21.376v-2.688h21.376z"
})));
export { SvgDrag as ReactComponent };
export default __webpack_public_path__ + "static/media/drag.175dd18d.svg";